import React from 'react'
import { connect } from 'react-redux'
import InsuranceActions from '../../Redux/InsuranceRedux'
import Modal from 'react-responsive-modal'
import CreateTravelPackage from '../../Containers/Insurance/CreateTravelPackage'
import UpdateTravelPackage from '../../Containers/Insurance/UpdateTravelPackage'
import ViewTravelPrice from '../../Containers/Insurance/ViewTravelPrice'
import EllipsisModal from '../../Components/EllipsisModal'
import AdvancedTable from '../../Components/AdvancedTable'

class TravelPackages extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {},
      page: 1
    }
  }

  componentDidMount = () => {
    this._fetchTravelPackages()
  }

  _fetchTravelPackages = (event) => {
    if (event) {
      event.preventDefault()
    }
    this.props.getTravelPackage()
  }

  _deleteTravelPackage = () => {
    let form = {
      status: 0
    }
    let data = {
      id: this.state.detail.id,
      form
    }
    this.props.deleteTravelPackage(data)
    setTimeout(() => {
      this._toggleModal()
    }, 250)
  }

  _selectItem = (item, action) => {
    this.setState({ detail: item })
    this._toggleModal(action)
  }

  _toggleModal = (action = null) => {
    this.setState({ showModal: action })
    if (!action) {
      this._fetchTravelPackages()
    }
  }

  render () {
    const { insurance } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Travel Package List
              {
                (insurance.fetching || insurance.processing) &&
                <div className='badge badge-info ml-2'>{ insurance.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
            <button className='btn btn-primary' onClick={() => this._toggleModal('create-travel-package')}><i className='fa fa-plus' /> Create Travel Package</button>
          </div>
        </header>
        <section className='section'>
          {
            !(insurance.fetching || insurance.processing) && insurance.err &&
            <div className='alert alert-danger'>{insurance.err}</div>
          }
          <AdvancedTable
            colSpan={6}
            header={[
              { field: 'Package Name', className: 'text-left' },
              { field: 'Type' },
              { field: 'Destination' },
              { field: 'View', colSpan: 2 },
              { field: 'Edit' },
              { field: 'Delete' }
            ]}
            body={
              insurance.data &&
              insurance.data.length > 0 &&
              insurance.data.map(item => ([
                { field: item.name, className: 'text-left' },
                { field: item.type },
                { field: item.destination_type },
                {
                  field: <button className='btn btn-info' onClick={() => this._selectItem(item, 'view-travel-price')}>
                    <i className='fa fa-eye' /> Price List
                  </button>
                },
                {
                  field: <EllipsisModal descriptor='Description' name={item.name} description={item.description} type='HTML' />
                },
                {
                  field: <button className='btn btn-primary' onClick={() => this._selectItem(item, 'update-travel-package')} >
                    <i className='fa fa-edit' />
                  </button>
                },
                {
                  field: <button className='btn btn-danger' onClick={() => this._selectItem(item, 'delete-travel-package')} >
                    <i className='fa fa-trash' />
                  </button>
                }
              ]))
            }
          />
        </section>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'view-travel-price'} onClose={this._toggleModal} closeOnOverlayClick>
          <ViewTravelPrice uuid={this.state.detail.id} closeModal={() => this._toggleModal()} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'create-travel-package'} onClose={this._toggleModal} closeOnOverlayClick>
          <CreateTravelPackage closeModal={() => this._toggleModal()} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'update-travel-package'} onClose={this._toggleModal} closeOnOverlayClick>
          <UpdateTravelPackage detail={this.state.detail} closeModal={() => this._toggleModal()} />
        </Modal>
        <Modal classNames={{ modal: 'modal-large' }} open={this.state.showModal === 'delete-travel-package'} onClose={this._toggleModal} closeOnOverlayClick>
          <section className='section' style={{ width: '40vw' }}>
            <div className='title-block'>
              <h1>Delete Travel Package</h1>
            </div>
            <div className='text-center'>
              <h4>{this.state.detail.name}</h4>
            </div>
            <div className='text-center'>
              <button className='btn btn-lg btn-secondary mr-2' onClick={() => this._toggleModal()}>Close</button>
              <button className='btn btn-lg btn-danger' onClick={() => this._deleteTravelPackage()}>Delete</button>
            </div>
          </section>
        </Modal>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  insurance: state.insurance
})

const dispatchToProps = (dispatch) => ({
  getTravelPackage: (data) => dispatch(InsuranceActions.getTravelPackageRequest(data)),
  deleteTravelPackage: (data) => dispatch(InsuranceActions.deleteTravelPackageRequest(data))
})

export default connect(stateToProps, dispatchToProps)(TravelPackages)



// WEBPACK FOOTER //
// ./src/Pages/Insurance/TravelPackageList.js